import { CarrierSubmissionClient } from 'clients';
import { QueryKeys } from 'enums';
import { CarrierSubmission, CarrierSubmissionSearchFilter } from 'types';
import { UseQueryBaseRetrieveOptions, UseQueryBaseSearchOptions } from './query/types';
import { useQueryRetrieve, useQuerySearch } from './query/useQuery';

export function useRetrieveCarrierSubmission(props: UseQueryBaseRetrieveOptions<CarrierSubmission>) {
  const { id, queryOptions, enabled } = props;
  return useQueryRetrieve<CarrierSubmission, CarrierSubmission, CarrierSubmissionClient>({
    queryKey: QueryKeys.CarrierSubmission,
    clientClass: CarrierSubmissionClient,
    id,
    enabled,
    queryOptions,
  });
}

export function useSearchCarrierSubmissions(
  props: UseQueryBaseSearchOptions<CarrierSubmission, CarrierSubmissionSearchFilter> = {},
) {
  const { filter, queryOptions, enabled } = props;
  return useQuerySearch<CarrierSubmission, CarrierSubmission, CarrierSubmissionClient, CarrierSubmissionSearchFilter>({
    queryKey: QueryKeys.CarrierSubmissions,
    clientClass: CarrierSubmissionClient,
    enabled,
    filter,
    queryOptions,
  });
}
